export interface PembobotanMain {
  id: number
  ulid: string
  code: string
  name: string
  value: number
  is_active: boolean
  id_parameter_penilaian: number
  created_at: string
  updated_at: string
}

export interface PembobotanDataModel {
  main: {
    data: PembobotanMain[];
    total: number;
  };
}

export enum PembobotanActionType {
  GetPembobotan = "⌘➝Parameter Setting➝Scoring➝GetPembobotan",
}

export type PembobotanAction = {
  type: PembobotanActionType.GetPembobotan;
  data: {
    data: PembobotanMain[];
    total: number;
  };
};
